export const userInitalState = {
  userProfile: {},
};
